import OapMarkupRenderingDelay from './code/Script/components/OapMarkupRenderingDelay.vue';

export default {
  components: {
    OapMarkupRenderingDelay,
  },
};
